import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./Components/Navigation";
import Hero from "./Components/Hero";
import Marquee from "./Components/Marquee";
import Features from "./Components/Features";
import ProductTour from "./Components/ProductTour";
import Customization from "./Components/Customization";
import Admin from "./Components/Admin";
import Pricing from "./Components/Pricing";
import FAQ from "./Components/FAQ";
import CallToAction from "./Components/CallToAction";
import Footer from "./Components/Footer";
import ScrollProgress from "./Components/ui/ScrollProgress";
import FloatingActions from "./Components/ui/FloatingActions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import useReveal from "./hooks/useReveal";

export function MainPage() {
  useReveal();

  return (
    <div className="font-sans antialiased text-midnight bg-softIvory">
      <ScrollProgress />
      <Navigation />
      <main>
        <Hero />
        <Marquee />
        <Features />
        <ProductTour />
        <Customization />
        <Admin />
        <Pricing />
        <FAQ />
        <CallToAction />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/privacidade" element={<PrivacyPolicy />} />
        <Route path="/termos-de-uso" element={<TermsOfUse />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
